export const APP_STARTED = 'APP_STARTED';
export const APP_CONTEXT_SET = 'APP_CONTEXT_SET';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const INITIALIZE_ADMIN_AUTH = 'INITIALIZE_ADMIN_AUTH';
export const PORTAL_SCOPES_REQUESTED = 'PORTAL_SCOPES_REQUESTED';
export const PORTAL_SCOPES_RECEIVED = 'PORTAL_SCOPES_RECEIVED';
export const PORTAL_SCOPES_FAILED = 'PORTAL_SCOPES_FAILED';
export const REVIEW_WRITE_REQUESTED = 'REVIEW_WRITE_REQUESTED';
export const REVIEW_WRITE_RECEIVED = 'REVIEW_WRITE_RECEIVED';
export const REVIEW_WRITE_FAILED = 'REVIEW_WRITE_FAILED';
export const REVIEW_SUBMITTED_RESET = 'REVIEW_SUBMITTED_RESET';
export const STOREFRONT_RESULTS_VIEW_UPDATED = 'STOREFRONT_RESULTS_VIEW_UPDATED';
export const REVIEWS_LIST_REQUESTED = 'REVIEWS_LIST_REQUESTED';
export const REVIEWS_LIST_RECEIVED = 'REVIEWS_LIST_RECEIVED';
export const REVIEWS_LIST_FAILED = 'REVIEWS_LIST_FAILED';
export const REVIEWS_LIST_RESET = 'REVIEWS_LIST_RESET';
export const REVIEW_STATS_REQUESTED = 'REVIEW_STATS_REQUESTED';
export const REVIEW_STATS_RECEIVED = 'REVIEW_STATS_RECEIVED';
export const REVIEW_STATS_FAILED = 'REVIEW_STATS_FAILED';
export const REVIEW_STATS_RESET = 'REVIEW_STATS_RESET';
export const REVIEW_FILTERS_INITIALIZED = 'REVIEW_FILTERS_INITIALIZED';
export const REVIEW_FILTERS_UPDATED = 'REVIEW_FILTERS_UPDATED';
export const REVIEW_HELPFUL_REQUESTED = 'REVIEW_HELPFUL_REQUESTED';
export const REVIEW_HELPFUL_RECEIVED = 'REVIEW_HELPFUL_RECEIVED';
export const REVIEW_HELPFUL_FAILED = 'REVIEW_HELPFUL_FAILED';
export const THEME_DETAILS_SLUG_UPDATED = 'THEME_DETAILS_SLUG_UPDATED';
export const THEME_DETAILS_SLUG_RESET = 'THEME_DETAILS_SLUG_RESET';